export { default as Status } from "./Status.vue";
export { default as StatusList } from "./StatusList.vue";
import { Calendar, CheckCircleBroken, Open } from "@/Icons";

export const StatusType = Object.freeze({
    OPEN: "open",
    SCHEDULED: "scheduled",
    COMPLETED: "completed",
});

export const statuses = [
    {
        id: StatusType.OPEN,
        label: "components.filters.status.open",
        icon: Open,
    },
    {
        id: StatusType.SCHEDULED,
        label: "components.filters.status.scheduled",
        icon: Calendar,
        strokeWidth: 2,
    },
    {
        id: StatusType.COMPLETED,
        label: "components.filters.status.completed",
        icon: CheckCircleBroken,
        strokeWidth: 3,
    },
];
